import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { listStores } from "../redux/slices/storeSlice";

const AdminRoute = ({ children }) => {
  const signinData = useSelector((state) => state?.userSignin);
  const { userInfo } = signinData;

  const { stores } = useSelector((state) => state?.listStores);
  const dispatch = useDispatch();

  const id = userInfo?.data?.id;

  useEffect(() => {
    dispatch(listStores({ slug: id }));
  }, [dispatch, id]);

  if (stores && !stores?.data?.length > 0) {
    <Navigate to="/login" />;
  }

  return userInfo?.data?.accessToken ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" />
  );
};

export default AdminRoute;
